import { Typography } from "@material-tailwind/react";
import FeatureComponent from "./FeatureComponent";
import { t } from "i18next";

function FeaturesComponent() {
  const features = [
    {
      id: "1",
      Icon: () => (
        <>
          <div className="w-[40px] h-[42px]">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 40 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M30.96 12.9185L31.8747 12.0038C33.3902 10.4883 35.8473 10.4883 37.3628 12.0038C38.8783 13.5193 38.8783 15.9764 37.3628 17.4919L36.4481 18.4065M30.96 12.9185C30.96 12.9185 31.0744 14.8622 32.7894 16.5772C34.5044 18.2922 36.4481 18.4065 36.4481 18.4065M30.96 12.9185L22.551 21.3275C21.9814 21.8971 21.6966 22.1819 21.4517 22.4959C21.1628 22.8663 20.9151 23.2671 20.713 23.6911C20.5417 24.0506 20.4143 24.4327 20.1596 25.1968L19.3441 27.6434L19.0803 28.4349M36.4481 18.4065L28.039 26.8156C27.4695 27.3852 27.1847 27.67 26.8707 27.9149C26.5003 28.2038 26.0995 28.4515 25.6755 28.6536C25.316 28.8249 24.9339 28.9523 24.1697 29.207L21.7232 30.0225L20.9317 30.2863M20.9317 30.2863L20.1402 30.5502C19.7641 30.6755 19.3495 30.5776 19.0692 30.2974C18.7889 30.0171 18.6911 29.6025 18.8164 29.2264L19.0803 28.4349M20.9317 30.2863L19.0803 28.4349"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M10.8682 22.7109H15.8023"
                stroke="#FF6104"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M10.8682 14.8164H23.697"
                stroke="#FF6104"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M10.8682 30.6016H13.8287"
                stroke="#FF6104"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M34.2138 3.3123C31.9015 1 28.1799 1 20.7367 1H16.7894C9.34619 1 5.6246 1 3.3123 3.3123C1 5.6246 1 9.34619 1 16.7894V24.6841C1 32.1272 1 35.8488 3.3123 38.1611C5.6246 40.4734 9.34619 40.4734 16.7894 40.4734H20.7367C28.1799 40.4734 31.9015 40.4734 34.2138 38.1611C36.0751 36.2998 36.4381 33.5252 36.5089 28.6314"
                stroke="#FF6104"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </>
      ),
      title: t("ProjectManagement"),
      text: t("ProjectManagementDescription"),
    },
    {
      id: "2",
      Icon: () => (
        <>
          <div className="w-[41px] h-[42px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 41 42"
              fill="none"
            >
              <path
                d="M37.1409 22.0142L38.1626 18.2014C39.3551 13.7506 39.9514 11.5252 39.5024 9.59934C39.1478 8.0787 38.3503 6.69736 37.2107 5.62998C35.7674 4.27817 33.542 3.68188 29.0912 2.48929C24.6404 1.29671 22.415 0.700415 20.4891 1.14946C18.9685 1.50402 17.5872 2.30154 16.5198 3.44117C15.3624 4.67691 14.7588 6.48596 13.8607 9.77418C13.7098 10.3264 13.5507 10.9204 13.3792 11.5604L13.3791 11.5607L12.3575 15.3735C11.1649 19.8243 10.5686 22.0497 11.0176 23.9755C11.3722 25.4962 12.1697 26.8775 13.3093 27.9449C14.7526 29.2967 16.978 29.893 21.4288 31.0856L21.4288 31.0856C25.4405 32.1605 27.6442 32.751 29.4503 32.5282C29.6479 32.5038 29.8409 32.4697 30.0309 32.4254C31.5515 32.0709 32.9328 31.2733 34.0002 30.1337C35.352 28.6904 35.9483 26.465 37.1409 22.0142Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M29.4505 32.5277C29.039 33.7879 28.3154 34.9279 27.3425 35.8391C25.8992 37.1909 23.6738 37.7872 19.223 38.9798C14.7722 40.1724 12.5468 40.7687 10.621 40.3196C9.10035 39.965 7.71901 39.1675 6.65163 38.0279C5.29982 36.5846 4.70353 34.3592 3.51094 29.9084L2.48929 26.0956C1.29671 21.6448 0.700415 19.4194 1.14946 17.4935C1.50402 15.9729 2.30154 14.5915 3.44117 13.5242C4.88449 12.1724 7.10988 11.5761 11.5607 10.3835C12.4027 10.1579 13.1651 9.95358 13.8609 9.77368"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M20.2969 16.7891L29.829 19.3432"
                stroke="#FF6104"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M18.7627 22.5117L24.482 24.0442"
                stroke="#FF6104"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </>
      ),
      title: t("TemplateCreationAndUsage"),
      text: t("TemplateCreationAndUsageDescription"),
    },
    {
      id: "3",
      Icon: () => (
        <>
          <div className="w-[42px] h-[38px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 42 38"
              fill="none"
            >
              <path
                d="M1 30.6046C1 28.7654 1 27.8458 1.30047 27.1204C1.7011 26.1531 2.46955 25.3847 3.43676 24.9841C4.16217 24.6836 5.08178 24.6836 6.92101 24.6836H34.5524C36.3916 24.6836 37.3113 24.6836 38.0367 24.9841C39.0039 25.3847 39.7723 26.1531 40.1729 27.1204C40.4734 27.8458 40.4734 28.7654 40.4734 30.6046C40.4734 32.4438 40.4734 33.3635 40.1729 34.0889C39.7723 35.0561 39.0039 35.8245 38.0367 36.2251C37.3113 36.5256 36.3916 36.5256 34.5524 36.5256H6.92101C5.08178 36.5256 4.16217 36.5256 3.43676 36.2251C2.46955 35.8245 1.7011 35.0561 1.30047 34.0889C1 33.3635 1 32.4438 1 30.6046Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M1 18.7609C1 16.9216 1 16.002 1.30047 15.2766C1.7011 14.3094 2.46955 13.5409 3.43676 13.1403C4.16217 12.8398 5.08178 12.8398 6.92101 12.8398H34.5524C36.3916 12.8398 37.3113 12.8398 38.0367 13.1403C39.0039 13.5409 39.7723 14.3094 40.1729 15.2766C40.4734 16.002 40.4734 16.9216 40.4734 18.7609C40.4734 20.6001 40.4734 21.5197 40.1729 22.2451C39.7723 23.2123 39.0039 23.9808 38.0367 24.3814C37.3113 24.6819 36.3916 24.6819 34.5524 24.6819H6.92101C5.08178 24.6819 4.16217 24.6819 3.43676 24.3814C2.46955 23.9808 1.7011 23.2123 1.30047 22.2451C1 21.5197 1 20.6001 1 18.7609Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M1 6.92101C1 5.08178 1 4.16217 1.30047 3.43676C1.7011 2.46955 2.46955 1.7011 3.43676 1.30047C4.16217 1 5.08178 1 6.92101 1H34.5524C36.3916 1 37.3113 1 38.0367 1.30047C39.0039 1.7011 39.7723 2.46955 40.1729 3.43676C40.4734 4.16217 40.4734 5.08178 40.4734 6.92101C40.4734 8.76024 40.4734 9.67986 40.1729 10.4053C39.7723 11.3725 39.0039 12.1409 38.0367 12.5416C37.3113 12.842 36.3916 12.842 34.5524 12.842H6.92101C5.08178 12.842 4.16217 12.842 3.43676 12.5416C2.46955 12.1409 1.7011 11.3725 1.30047 10.4053C1 9.67986 1 8.76024 1 6.92101Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <circle cx="6.92094" cy="18.7627" r="1.97367" fill="#FF6104" />
              <circle cx="6.92094" cy="6.91898" r="1.97367" fill="#FF6104" />
              <circle cx="6.92094" cy="30.6026" r="1.97367" fill="#FF6104" />
            </svg>
          </div>
        </>
      ),
      title: t("RoombookManagement"),
      text: t("RoombookManagementDescription"),
    },
    {
      id: "4",
      Icon: () => (
        <>
          <div className="w-[38px] h-[42px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 38 42"
              fill="none"
            >
              <path
                d="M3.60134 37.583C6.20267 40.4734 10.3895 40.4734 18.763 40.4734C27.1366 40.4734 31.3234 40.4734 33.9247 37.583C36.5261 34.6927 36.5261 30.0407 36.5261 20.7367C36.5261 11.4327 36.5261 6.78075 33.9247 3.89037C31.3234 1 27.1366 1 18.763 1C10.3895 1 6.20267 1 3.60134 3.89037C1 6.78075 1 11.4327 1 20.7367C1 30.0407 1 34.6927 3.60134 37.583Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M8.89551 12.8419C8.89551 11.9241 8.89551 11.4653 8.99638 11.0888C9.27013 10.0672 10.0681 9.26916 11.0898 8.99541C11.4663 8.89453 11.9251 8.89453 12.8428 8.89453H24.6849C25.6026 8.89453 26.0615 8.89453 26.4379 8.99541C27.4596 9.26916 28.2576 10.0672 28.5313 11.0888C28.6322 11.4653 28.6322 11.9241 28.6322 12.8419C28.6322 13.7596 28.6322 14.2185 28.5313 14.5949C28.2576 15.6166 27.4596 16.4146 26.4379 16.6883C26.0615 16.7892 25.6026 16.7892 24.6849 16.7892H12.8428C11.9251 16.7892 11.4663 16.7892 11.0898 16.6883C10.0681 16.4146 9.27013 15.6166 8.99638 14.5949C8.89551 14.2185 8.89551 13.7596 8.89551 12.8419Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <circle cx="10.8692" cy="22.708" r="1.97367" fill="#FF6104" />
              <circle cx="10.8692" cy="30.6026" r="1.97367" fill="#FF6104" />
              <circle cx="18.7627" cy="22.708" r="1.97367" fill="#FF6104" />
              <circle cx="18.7627" cy="30.6026" r="1.97367" fill="#FF6104" />
              <circle cx="26.6582" cy="22.708" r="1.97367" fill="#FF6104" />
              <circle cx="26.6582" cy="30.6026" r="1.97367" fill="#FF6104" />
            </svg>
          </div>
        </>
      ),
      title: t("Estimation"),
      text: t("EstimationDescription"),
    },
    {
      id: "5",
      Icon: () => (
        <>
          <div className="w-[38px] h-[41px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 38 41"
              fill="none"
            >
              <path
                d="M30.6051 12.8398L32.4775 13.464C34.4314 14.1153 35.4084 14.441 35.9673 15.2163C36.5261 15.9916 36.5261 17.0215 36.5261 19.0811V30.2654C36.5261 32.8132 36.5261 34.0871 35.8556 34.9054C35.6279 35.1834 35.3514 35.4175 35.0399 35.5964C34.1224 36.1233 32.8658 35.9139 30.3527 35.495C27.8729 35.0817 26.633 34.8751 25.4041 34.9779C24.9729 35.014 24.5444 35.0784 24.1216 35.1707C22.9168 35.4339 21.7826 36.0009 19.5143 37.1351C16.5543 38.6151 15.0743 39.3551 13.4989 39.5832C13.0244 39.6519 12.5456 39.6859 12.0661 39.685C10.4743 39.682 8.91809 39.1633 5.80565 38.1258L5.04862 37.8734C3.09463 37.2221 2.11764 36.8964 1.55882 36.1211C1 35.3458 1 34.316 1 32.2563V22.5266C1 19.2525 1 17.6155 1.96397 16.735C2.13265 16.581 2.31859 16.447 2.51808 16.3357C3.65817 15.6996 5.21121 16.2173 8.3173 17.2526"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M6.9209 12.2505C6.9209 6.03703 12.2228 1 18.7629 1C25.3031 1 30.6049 6.03703 30.6049 12.2505C30.6049 18.4153 26.8254 25.6091 20.9284 28.1816C19.5538 28.7813 17.9721 28.7813 16.5974 28.1816C10.7005 25.6091 6.9209 18.4153 6.9209 12.2505Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <circle
                cx="18.7628"
                cy="12.8419"
                r="3.94734"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
            </svg>
          </div>
        </>
      ),
      title: t("Zoning"),
      text: t("ZoningDescription"),
    },
    {
      id: "6",
      Icon: () => (
        <>
          <div className="w-[40px] h-[39px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 38 37"
              fill="none"
            >
              <path
                d="M1 12.269C1 9.36067 1 7.90653 1.77494 7.0584C2.05008 6.75728 2.38447 6.51626 2.75715 6.35047C3.80681 5.88349 5.18633 6.34334 7.94537 7.26302C10.0518 7.96515 11.105 8.31622 12.1692 8.27988C12.5601 8.26653 12.9486 8.21449 13.3292 8.12453C14.3655 7.87957 15.2892 7.26376 17.1367 6.03214L19.865 4.21323C22.2315 2.63557 23.4148 1.84674 24.773 1.66485C26.1313 1.48295 27.4804 1.93266 30.1786 2.83206L32.4775 3.59835C34.4314 4.24968 35.4084 4.57535 35.9673 5.35067C36.5261 6.12599 36.5261 7.15583 36.5261 9.21552V25.2582C36.5261 28.1665 36.5261 29.6206 35.7511 30.4688C35.476 30.7699 35.1416 31.0109 34.7689 31.1767C33.7193 31.6437 32.3397 31.1838 29.5807 30.2642C27.4743 29.562 26.4211 29.211 25.3569 29.2473C24.966 29.2606 24.5774 29.3127 24.1969 29.4026C23.1606 29.6476 22.2368 30.2634 20.3894 31.495L17.661 33.3139C15.2946 34.8916 14.1113 35.6804 12.7531 35.8623C11.3948 36.0442 10.0457 35.5945 7.3475 34.6951L5.04862 33.9288C3.09463 33.2775 2.11764 32.9518 1.55882 32.1765C1 31.4012 1 30.3713 1 28.3117V12.269Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M12.8418 8.17969V35.5375"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path d="M24.6846 1V28.6314" stroke="#FF6104" strokeWidth="1.5" />
            </svg>
          </div>
        </>
      ),
      title: t("LegendGeneration"),
      text: t("LegendGenerationDescription"),
    },
    {
      id: "7",
      Icon: () => (
        <>
          <div className="w-[42px] h-[42px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 42 42"
              fill="none"
            >
              <path
                d="M40.4734 40.4727H1"
                stroke="#FF6104"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M38.5002 40.474V25.6714C38.5002 24.0364 37.1748 22.7109 35.5397 22.7109H29.6187C27.9837 22.7109 26.6582 24.0364 26.6582 25.6714V40.474"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M26.6575 40.4734V6.92101C26.6575 4.12982 26.6575 2.73422 25.7903 1.86711C24.9232 1 23.5276 1 20.7364 1C17.9453 1 16.5497 1 15.6825 1.86711C14.8154 2.73422 14.8154 4.12982 14.8154 6.92101V40.4734"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M14.8157 40.4712V15.8004C14.8157 14.1653 13.4902 12.8398 11.8552 12.8398H5.93414C4.2991 12.8398 2.97363 14.1653 2.97363 15.8004V40.4712"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
            </svg>
          </div>
        </>
      ),
      title: t("Visualization"),
      text: t("VisualizationDescription"),
    },
    {
      id: "8",
      Icon: () => (
        <>
          <div className="w-[39px] h-[42px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 39 42"
              fill="none"
            >
              <circle
                cx="19.6066"
                cy="20.7374"
                r="5.92101"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
              <path
                d="M23.0924 1.30047C22.367 1 21.4474 1 19.6082 1C17.769 1 16.8493 1 16.1239 1.30047C15.1567 1.7011 14.3883 2.46955 13.9876 3.43676C13.8048 3.87828 13.7332 4.39176 13.7052 5.14074C13.664 6.24144 13.0995 7.26028 12.1456 7.811C11.1918 8.36172 10.0272 8.34115 9.0534 7.82645C8.39074 7.47621 7.91027 7.28145 7.43645 7.21907C6.39851 7.08242 5.34879 7.36369 4.51823 8.001C3.89531 8.47899 3.4355 9.2754 2.51589 10.8682C1.59627 12.461 1.13646 13.2575 1.03398 14.0359C0.897331 15.0739 1.1786 16.1236 1.81591 16.9541C2.10681 17.3332 2.51563 17.6519 3.15013 18.0506C4.08292 18.6367 4.68309 19.6351 4.68303 20.7368C4.68297 21.8383 4.08282 22.8366 3.15013 23.4226C2.51552 23.8213 2.10664 24.14 1.81572 24.5192C1.17841 25.3497 0.897138 26.3994 1.03379 27.4374C1.13627 28.2158 1.59608 29.0122 2.51569 30.6051C3.43531 32.1979 3.89512 32.9943 4.51804 33.4723C5.3486 34.1096 6.39832 34.3909 7.43626 34.2542C7.91005 34.1918 8.39049 33.9971 9.05309 33.6469C10.027 33.1322 11.1916 33.1116 12.1456 33.6624C13.0995 34.2131 13.664 35.232 13.7052 36.3328C13.7332 37.0817 13.8048 37.5952 13.9876 38.0367C14.3883 39.0039 15.1567 39.7723 16.1239 40.1729C16.8493 40.4734 17.769 40.4734 19.6082 40.4734C21.4474 40.4734 22.367 40.4734 23.0924 40.1729C24.0596 39.7723 24.8281 39.0039 25.2287 38.0367C25.4116 37.5951 25.4832 37.0816 25.5112 36.3326C25.5523 35.2319 26.1168 34.2131 27.0706 33.6624C28.0246 33.1115 29.1892 33.1321 30.1632 33.6468C30.8257 33.997 31.3061 34.1917 31.7799 34.2541C32.8179 34.3907 33.8676 34.1095 34.6981 33.4721C35.3211 32.9942 35.7809 32.1977 36.7005 30.6049C37.6201 29.0121 38.0799 28.2157 38.1824 27.4372C38.319 26.3993 38.0378 25.3496 37.4005 24.519C37.1095 24.1399 36.7007 23.8212 36.0661 23.4225C35.1334 22.8364 34.5333 21.8381 34.5333 20.7365C34.5334 19.6351 35.1335 18.6369 36.0661 18.0509C36.7008 17.6522 37.1097 17.3334 37.4007 16.9543C38.038 16.1237 38.3192 15.074 38.1826 14.036C38.0801 13.2576 37.6203 12.4612 36.7007 10.8684C35.7811 9.27554 35.3213 8.47912 34.6983 8.00114C33.8678 7.36383 32.8181 7.08256 31.7801 7.21921C31.3063 7.28158 30.8259 7.47632 30.1633 7.82653C29.1894 8.34125 28.0248 8.36183 27.0708 7.81106C26.1169 7.2603 25.5524 6.2414 25.5112 5.14064C25.4832 4.39171 25.4116 3.87826 25.2287 3.43676C24.8281 2.46955 24.0596 1.7011 23.0924 1.30047Z"
                stroke="#FF6104"
                strokeWidth="1.5"
              />
            </svg>
          </div>
        </>
      ),
      title: t("UserSettings"),
      text: t("UserSettingsDescription"),
    },
  ];

  return (
    <>
      <div className="bg-#ECECEC w-full py-[30px] lg:py-[60px]">
        <Typography variant="h2" className="uppercase text-xl 2xl:text-3xl font-bold tracking-[0.9px] text-center mb-[30px] lg:mb-[60px]">
          {t("Features")}
        </Typography>
        <div className="w-full flex justify-center mt-20">
          <div className="max-w-[1400px] w-full px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-[70px] w-fit mx-auto">
              {features.map((feature) => (
                <FeatureComponent key={feature.id} feature={feature} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeaturesComponent;
